'use client';

import { ALink } from '@ssv-website/web-ui';

export const EnterButton = (props: {
  text: string;
  link?: string;
  onClick?: () => void;
}) => {
  const { text, link, onClick } = props;
  return (
    <div className="flex justify-center">
      <ALink link={link ?? '/'}>
        <button
          className="px-6 py-3 text-xs rounded-md mt-8 bg-big-btn text-white shadow-btn2"
          onClick={onClick}
        >
          {text}
        </button>
      </ALink>
    </div>
  );
};
